import { useContext, useState, useEffect, useRef } from 'react';
import PaymentOptions from './PaymentOptions';
import { CheckoutContext } from './CheckoutContext';
import { numberFormat, showToast } from '../../Utils';
import { format } from 'date-fns';

import { getListPaymentMethod, checkoutBooking } from '../../API/ServiceAPI';

import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import 'react-awesome-slider/dist/styles.css';


const AutoplaySlider = withAutoplay(AwesomeSlider);

function CheckoutPayment() {
  const { data, updateData } = useContext(CheckoutContext);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [submited, setSubmited] = useState(false);
  const [loading, setLoading] = useState(false);

  const [voucherCode, setVoucherCode] = useState('')
  const [timeoutId, setTimeoutId] = useState(null)

  useEffect(() => {
    if (!voucherCode) return

    // Debounce: wait 500ms after user stops typing
    if (timeoutId) clearTimeout(timeoutId)

    const id = setTimeout(() => {
      fetch(`/api/voucher/validate?code=${voucherCode}`)
        .then(res => res.json())
        .then(data => {
          if (data.valid) {
            // onVoucherValidated(data)
          } else {
            // handle invalid
          }
        })
        .catch(err => {
          console.error('Voucher validation failed', err)
        })
    }, 500)

    setTimeoutId(id)

    // Clean up on unmount or when voucherCode changes
    return () => clearTimeout(id)
  }, [voucherCode])


  useEffect(() => {
    const onSuccessHandler = (responseJSON) => setPaymentMethods(responseJSON);
    const onFailureHandler = (messages) => console.debug("FAIL", messages);

    if (data.total === 0) {
      setPaymentMethods([{
        "pg_code": null,
        "pg_name": "FREE TRIAL",
        "admin_fee": 0
      }]);
    } else {
      getListPaymentMethod(data.contact.phone, data.total + data.service_fee, onSuccessHandler, onFailureHandler);
    }
  }, [data])

  const handleChangePaymentMethod = (selected) => {
    updateData({ ...data, paymentMethod: selected });
  }

  const validate = () => {
    if (data.paymentMethod.pg_code === undefined)
      return { valid: false, msg: "Silahkan pilih metode pembayaran" }


    return { valid: true, msg: "OK" };
  }

  const onSubmit = () => {
    let { valid, msg } = validate();

    if (valid) {
      setLoading(true);
      const onSuccessHandler = (responseJSON) => {
        setLoading(false);
        if (data.total === 0) {
          showToast("Succees", "Succees", "Booking berhasil dipesan.");
        }
        window.location = responseJSON.payment_url;
      }
      const onFailureHandler = (messages) => {
        setLoading(false);
        showToast("Error", "Fail", messages);
      }

      checkoutBooking(data, onSuccessHandler, onFailureHandler)
    } else {
      showToast("Error", "Alert", msg);
    }
  }

  return (
    <div className='md:flex md:gap-x-6 pt-12'>

      <div className='md:w-7/12'>
        <p className='text-md font-semibold mb-4'>Konfirmasi Pesanan</p>

        <div className='px-6 py-6 flex flex-col gap-y-8 border border-gray-300 rounded-xl mb-4 md:mb-0'>

          <div className="flex gap-x-4 flex-grow">
            <div className='gap-y-3 flex flex-col'>
              <p className='text-sm font-bold text-gray-500'>Nama Venue</p>
              <p className='text-sm font-semibold text-gray-800'>{data.venue.name}</p>
            </div>
            <div className="flex-grow" />
            <div className='gap-y-3 flex flex-col mt-0'>
              <p className='text-sm font-bold text-gray-500'>Tanggal Booking</p>
              <p className='text-sm font-semibold text-gray-800'>
                {format(data.selected_date, 'dd MMMM yyyy')}
              </p>
            </div>

          </div>
          <div className="flex gap-x-4 flex-grow">
            <div className='w-1/2 flex flex-col justify-start'>
              <p className="text-sm font-bold text-gray-800">TOTAL BAYAR</p>
              {data.paymentMethod === null ? (<>
                <p className="text-xs text-gray-800">Belum termasuk biaya admin</p>
              </>) : (<>
                <p className="text-xs text-gray-800">Sudah termasuk biaya admin</p>
              </>)}
            </div>
            <div className='w-1/2 flex justify-end'>
              <p className="text-lg font-bold text-gray-800">Rp</p>
              <p className="text-lg font-bold text-gray-800">{numberFormat(data.total, false)}</p>
            </div>
          </div>

          <hr />

          <div className='gap-y-3 flex flex-col flex-grow'>
            <p className='text-sm font-bold text-gray-500'>Jam Booking</p>
            {
              data.selected_schedule.map((item, index) => (

                <div key={index} className="flex gap-x-4 flex-grow">
                  <div className='w-1/2 flex justify-start'>
                    <p className="text-sm font-bold text-gray-800">{item.hour}</p>
                  </div>
                  <div className='w-1/2 flex justify-end flex-col'>
                    {
                      <div className='flex justify-end'>
                        <p className="text-sm font-bold text-gray-800">Rp</p>
                        <p className="text-sm font-semibold text-gray-800">{numberFormat(item.price, false)}</p>
                      </div>
                    }

                  </div>
                </div>
              ))
            }
          </div>

          {data.addons.length > 0 && (<>
            <div className='gap-y-3 flex flex-col flex-grow'>
              <p className='text-sm font-bold text-gray-500'>Tambahan Add On</p>
              {
                data.addons.map((item, index) => (
                  <div key={index} className="flex gap-x-4 flex-grow">
                    <div className='w-1/2 flex justify-start'>
                      <p className="text-sm font-bold text-gray-800">{item.name} {item.qty} {item.unit !== "Hour" ? item.unit : `x ${data.selected_schedule.length} ${item.unit} `}</p>
                    </div>
                    <div className='w-1/2 flex justify-end'>
                      <p className="text-sm font-bold text-gray-800">Rp</p>
                      {/* <div className="flex-grow" /> */}
                      <p className="text-sm font-bold text-gray-800">{numberFormat(item.unit !== "Hour" ? item.qty * item.price : item.qty * item.price * data.selected_schedule.length, false)}</p>
                    </div>
                  </div>
                ))
              }
            </div>
          </>)}
          <hr />
          <div className='gap-y-3 flex flex-col flex-grow mt-[-14px]'>


            <div className="flex gap-x-4 flex-grow">
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-bold text-gray-800">VOUCHER & DISKON</p>
              </div>
              <div className='w-1/2 flex justify-end'>
              </div>
            </div>

            {/* <div className="flex gap-x-4 flex-grow"> */}
            {/* Input */}
            {/* <div className="w-1/2 flex justify-end"> */}
            {/* <input */}
            {/* type="text" */}
            {/* value={voucherCode} */}
            {/* onChange={e => setVoucherCode(e.target.value)} */}
            {/* placeholder="Kode Voucher" */}
            {/* className="py-3 px-4 text-sm font-medium bg-[#F5F5F5] placeholder:text-gray-600 border border-[#F5F5F5] focus:border-[#1C62CC] focus-visible:outline-none rounded-lg" */}
            {/* /> */}
            {/* </div> */}

            {/* Nominal - Centered */}
            {/* <div className="w-1/2 flex justify-end items-center"> */}
            {/* <p className="text-sm font-semibold text-gray-800 mr-1">- Rp</p> */}
            {/* <p className="text-sm font-semibold text-gray-800"> */}
            {/* {numberFormat(data.voucher?.amount ?? 0, false)} */}
            {/* </p> */}
            {/* </div> */}
            {/* </div> */}

            <div className="flex gap-x-4 flex-grow">
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-semibold text-gray-800">Diskon Lapang</p>
              </div>
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-semibold text-gray-800">- Rp</p>
                {/* <div className="flex-grow" /> */}
                <p className="text-sm font-semibold text-gray-800">{numberFormat(data.discount, false)}</p>
              </div>
            </div>
            <div className="flex gap-x-4 flex-grow">
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-semibold text-gray-800">Diskon Pembayaran</p>
              </div>
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-semibold text-gray-800">- Rp</p>
                {/* <div className="flex-grow" /> */}
                <p className="text-sm font-semibold text-gray-800">{numberFormat(((data.paymentMethod !== null && data.paymentMethod.promo_is_active) ? data.paymentMethod?.discount_amount : 0), false)}</p>
              </div>
            </div>
            <hr />

            <div className="flex gap-x-4 flex-grow">
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-bold text-gray-800">BIAYA LAYANAN</p>
              </div>
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-bold text-gray-800">Rp{numberFormat(data.service_fee, false)}</p>
              </div>
            </div>
            <div className="flex gap-x-4 flex-grow">
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-bold text-gray-800">BIAYA ADMIN</p>
              </div>
              <div className='w-1/2 flex justify-end'>
                {
                  data.paymentMethod !== null ? (
                    <>
                      <p className="text-sm font-bold text-gray-800">Rp</p>
                      {/* <div className="flex-grow" /> */}
                      <p className="text-sm font-bold text-gray-800">{numberFormat((data.paymentMethod !== null ? data.paymentMethod?.admin_fee : 0), false)}</p>
                    </>
                  ) : (
                    <p className="text-sm font-bold text-gray-800">Belum Termasuk</p>
                  )
                }

              </div>
            </div>
            <div className="flex gap-x-4 flex-grow">
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-bold text-gray-800">TOTAL BAYAR</p>
              </div>
              <div className='w-1/2 flex justify-end'>
                <p className="text-sm font-bold text-gray-800">Rp</p>
                {/* <div className="flex-grow" /> */}
                <p className="text-sm font-bold text-gray-800">{numberFormat(data.total + ((data.paymentMethod !== null && data.paymentMethod.promo_is_active) ? (data.paymentMethod?.admin_fee) : 0) - (data.paymentMethod !== null ? (data.paymentMethod?.discount_amount) : 0), false)}</p>
              </div>
            </div>

          </div>
        </div>

        {/* <div className='bg-[#F5F5F5] rounded-2xl p-8 flex flex-col mb-8'>
          <p className='text-md font-semibold mb-4'>Kebijakan Booking Lapang</p>
          <div className='flex w-full items-start'>
            <ul className='list-[square] ml-5'>
              <li>
                <p className='text-gray-700 text-xs tracking-wide leading-loose mb-4'>
                  Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet.
                  Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui.
                  Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero,
                  sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar,
                  hendrerit id, lorem.
                </p>
              </li>
            </ul>
          </div>
        </div> */}

      </div>

      <div className='md:w-5/12'>

        {/* <p className='text-md font-semibold mb-4'>Kode Voucher</p>

        <div className="flex items-center space-x-4">
          <input
            type="text"
            ref={voucherCode}
            placeholder="Input Kode Voucher"
            className="py-3 px-4 text-sm font-medium flex-1 bg-[#F5F5F5] placeholder:text-gray-600 border border-[#F5F5F5] focus:border-[#1C62CC] focus-visible:outline-none rounded-lg"
          />

          <button
            className="bg-primaryRed text-white rounded-lg px-6 py-3 text-sm font-semibold w-auto"
            onClick={e => onSubmit()}
          >
            Gunakan
          </button>
        </div> */}



        {/* <div className=' flex flex-col mt-10 rounded-xl overflow-hidden'>
          <img src='/img_promo_main_blu.webp' className="w-full object-cover object-center" alt="Promo" />
        </div> */}

        <p className='text-md font-semibold' >Pilih Metode Pembayaran</p>

        <div className='flex flex-col gap-y-2'>
          <PaymentOptions
            plan={paymentMethods}
            onChange={handleChangePaymentMethod}
            readonly={submited} />
        </div>

        <div>
          {(!submited) && (
            <button
              className='w-full bg-primaryRed text-white rounded-lg px-10 py-3 text-sm font-semibold mt-4 disabled:opacity-50 disabled:cursor-not-allowed'
              onClick={e => onSubmit()}
              disabled={loading}
            >
              {loading ? 'Memproses...' : 'Lanjut Pembayaran'}
            </button>
          )}
        </div>

        {/* <div className=' flex flex-col mt-8 rounded-xl overflow-hidden  aspect-[414/250]'>
          <AutoplaySlider
            className='w-full h-full'
            play={true}
            bullets={true}
            buttons={false}
            cancelOnInteraction={false}
            interval={5000}
            media={[
              {
                source: '/img_promo_side_blu_1.webp',
              },
              {
                source: '/img_promo_side_blu_2.webp',
              },
            ]}
          />
        </div> */}

      </div>

    </div>
  );

}

export default CheckoutPayment;